import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const StyledMenuItem = styled(Link)`
  padding: 0.75rem 1.5rem;
  color: ${props => props.$isActive ? '#fff' : 'rgba(255, 255, 255, 0.9)'};
  text-decoration: none;
  display: block;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  font-size: 0.95rem;
  font-weight: ${props => props.$isActive ? '600' : '400'};
  outline: none;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
  }

  &:focus {
    outline: none;
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
  }

  @media (max-width: 900px) {
    font-size: 1.05rem;
    padding: 0.875rem 1.5rem;
  }
`;

const MenuItem = ({ to, children, exact = false }) => {
  const location = useLocation();
  const isActive = exact 
    ? location.pathname === to 
    : location.pathname.startsWith(to);

  return (
    <StyledMenuItem to={to} $isActive={isActive}>
      {children}
    </StyledMenuItem>
  );
};

export default MenuItem;

